// src/components/RequireAdmin.js
import { useUser } from '@clerk/clerk-react';
import { Navigate } from 'react-router-dom';

function RequireAdmin({ children }) {
  const { isLoaded, isSignedIn, user } = useUser();

  if (!isLoaded) {
    return (
      <div className="admin-loading">
        <p>Verifying session…</p>
      </div>
    );
  }

  if (!isSignedIn) {
    return <Navigate to="/" replace />;
  }

  if (user.publicMetadata?.role !== 'admin') {
    return <Navigate to="/" replace />;
  }

  return children;
}

export default RequireAdmin;
